<template>
  <b-modal id="modal-edit-smd-user" size="md" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="EditIcon" class="mr-05" />
        <span class="fs-18">Edit User Sosmed</span>
      </div>
    </template>
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0" v-if="local_data">
      <b-card-body>
        <validation-observer ref="formRules">
          <b-form>
            <!-- Info Platform (readonly) -->
            <b-form-group>
              <label>Platform</label>
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i :class="local_data.platform === 'facebook' ? 'bi bi-facebook' : 'bi bi-instagram'"></i>
                </b-input-group-prepend>
                <b-form-input :value="local_data.platform === 'facebook' ? 'Facebook' : 'Instagram'" readonly />
              </b-input-group>
              <small class="text-muted" style="font-size:10px">Platform tidak dapat diubah</small>
            </b-form-group>
            <!-- Username -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Username" rules="required">
                <label for="edit-smd-username">Username <span class="text-danger">*</span></label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input v-model="local_data.username" id="edit-smd-username" placeholder="Masukkan Username" />
                </b-input-group>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- Role -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Role" rules="required">
                <label for="edit-smd-role">Role <span class="text-danger">*</span></label>
                <select v-model="local_data.role" id="edit-smd-role" class="form-control">
                  <option value="" disabled>Pilih Role</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                </select>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <template #modal-footer>
      <b-button variant="outline-danger" size="sm" class="float-right mr-05" @click="cancel">Batal</b-button>
      <b-button variant="outline-info" size="sm" class="float-right" @click.prevent="submit">Simpan</b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, VBModal, BCard, BCardBody, BForm, BFormGroup, BInputGroup, BInputGroupPrepend, BFormInput, BButton } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "editSmdUser",
  components: {
    ValidationProvider, ValidationObserver,
    BModal, BCard, BCardBody, BForm, BFormGroup,
    BInputGroup, BInputGroupPrepend, BFormInput, BButton,
    "loader-component": floating_loader,
  },
  props: { data: Object },
  data() {
    return { is_loading: false, local_data: null, required };
  },
  watch: {
    data(val) { this.local_data = val ? { ...val } : null; },
  },
  methods: {
    submit() {
      this.$refs.formRules.validate().then((success) => {
        if (success) {
          this.is_loading = true;
          const api = process.env.VUE_APP_API_URL + "smd-users/edit/" + this.local_data._id;
          const params = { username: this.local_data.username, role: this.local_data.role, platform: this.local_data.platform };
          useJwt.axiosIns
            .put(api, { data: params })
            .then(() => {
              this.$bvModal.hide("modal-edit-smd-user");
              this.$parent.getData();
              this.$toast({ component: ToastificationContent, position: "top-right",
                props: { title: "Berhasil", icon: "CheckCircleIcon", variant: "success", text: "User sosmed berhasil diupdate" },
              });
            })
            .finally(() => { this.is_loading = false; });
        }
      });
    },
    cancel() { this.$bvModal.hide("modal-edit-smd-user"); },
  },
  directives: { "b-modal": VBModal },
};
</script>
